import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';
import { map } from 'rxjs/operators';

import { EntityResolverService } from '../entity-resolver/entity-resolver.service';
import { selectEntityState } from '../entity-store/entity-state';
import { deviate } from '../entity/entity-registry';
import { EntityActions, InternalEntityActions } from './entity-actions';

@Injectable()
export class EntityEffects {

  /** Effect that transforms an upsert action into an upsertMany which is handled by the {@see upsertEntities$} effect. */
  public upsertEntity$ = createEffect(() => this.actions$.pipe(
    ofType(EntityActions.upsert),
    map(action => InternalEntityActions.upsertMany({ entities: [action.entity], deviations: deviate(action.entity.typeKey, action.deviation) }))
  ));

  /** Effect that calls the EntityResolver and puts the given entities into the store afterwards. */
  public upsertEntities$ = createEffect(() => this.actions$.pipe(
    ofType(EntityActions.upsertMany),
    concatLatestFrom(() => this.store.select(selectEntityState)),
    tap(([action, { entitiesById }]) => this.entityResolver.resolve(action.entities, entitiesById, action.deviations)),
    map(([action]) => InternalEntityActions._upsertMany(action))
  ));

  constructor(private actions$: Actions, private store: Store, private entityResolver: EntityResolverService) {}

}


